module.exports = __webpack_public_path__ + "img/2_218.20b5ae06.png";